import { Marketplace } from '../../enums/marketplace.enum';

export class CarrierMarketplaceMappingViewModel {
  id: number = 0;
  carrierId: number = 0;
  companyId: number = 0;
  carrierName: string = '';
  marketplace: Marketplace = Marketplace.Unknown;
  shippingName: string = '';
  shippingCode: string = '';
}
